import { render, staticRenderFns } from "./forget-password.vue?vue&type=template&id=45401e67&scoped=true&"
import script from "./forget-password.vue?vue&type=script&lang=js&"
export * from "./forget-password.vue?vue&type=script&lang=js&"
import style0 from "./forget-password.vue?vue&type=style&index=0&id=45401e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45401e67",
  null
  
)

export default component.exports